<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--compact kgr-table--block table-groups table-employees kgr-table--striped printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('member.lastName') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('member.firstName') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('member.membershipNumber') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Adresse') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('member.phone') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('member.mobile') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Mitgliedsstatus') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="member in members"
                    :key="member.id"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        <span v-if="member.isShortProfileViewable === false">
                            {{ member.lastName }}<template v-if="member.academicTitle">, {{ member.academicTitle.value }}</template>
                        </span>
                        <a
                            v-else
                            :href="urlForMember(member.id)"
                            class="kgr-link kgr-link--unobtrusive"
                        >
                            {{ member.lastName }}<template v-if="member.academicTitle">, {{ member.academicTitle.value }}</template>
                        </a>
                    </td>
                    <td class="kgr-table__cell">
                        {{ member.firstName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ member.membershipNumber }}
                    </td>
                    <td class="kgr-table__cell">
                        <span class="kgr-text kgr-text--noWrap">{{ formatAddress(member) }}</span>
                    </td>
                    <td class="kgr-table__cell">
                        {{ member.phone }}
                    </td>
                    <td class="kgr-table__cell memberContractsLayerContainer">
                        {{ member.phoneMobile }}
                    </td>
                    <td
                        class="kgr-table__cell kgr-table__cell--noGrow"
                        :data-order="member.contractState.status"
                        style="position:relative"
                    >
                        <kgr-member-contract-state-icon
                            :state="member.contractState"
                        />

                        <kgr-member-contracts-layer
                            v-if="showContractsLayer(member)"
                            :member-contract-history="member.contractHistory"
                            :animate="true"
                            class="memberContractsLayer"
                        />
                        <a
                            :href="urlForMemberContracts(member.id)"
                            class="kgr-table__action"
                            @mouseover="toggleContractsLayer(member, true)"
                            @mouseout="toggleContractsLayer(member, false)"
                        >
                            <kgr-icon-list
                                style="vertical-align: middle;pointer-events: none"
                            />
                        </a>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                        <a
                            v-if="member.isEditableBasicData"
                            :href="urlForMemberEdit(member.id)"
                            class="kgr-table__action"
                        >
                            <kgr-icon icon-class="edit" />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Icon from '../common/icon/Icon.vue';
import IconList from '../common/icon/IconList.vue';
import KgrMemberContractStateIcon from './MemberContractStateIcon.vue';
import MemberContracsLayer from './MemberContracsLayer.vue';
import UrlMixin from './UrlMixin';

export default {
    components: {
        KgrMemberContractStateIcon,
        'kgr-member-contracts-layer': MemberContracsLayer,
        'kgr-icon-list': IconList,
        'kgr-icon': Icon,
    },
    mixins: [UrlMixin],
    props: {
        members: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            visibleContractLayer: null,
        }
    },
    methods: {
        toggleContractsLayer(member, visible) {
            if(null === member.contractHistory) {
                return;
            }
            this.visibleContractLayer = visible ? member : null;
        },
        showContractsLayer(member) {
            return member.contractHistory !== null && member === this.visibleContractLayer;
        },
        formatAddress(member) {
            const addressParts = [];

            if (member.careOf) {
                addressParts.push('c/o ' + member.careOf);
            }
            if (member.street) {
                addressParts.push(member.street);
            }
            if (member.zip || member.city) {
                const city = [];
                if (member.zip) {
                    city.push(member.zip);
                }
                if (member.city) {
                    city.push(member.city);
                }

                addressParts.push(city.join(' '));
            }

            return addressParts.join(', ');
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.memberContractsLayerContainer {
    position: relative;
}
.memberContractsLayer {
    position: absolute;
    right: 110%;
    padding: 10px;
    background-color: white;
    z-index:55;
    box-shadow: 1px 1px 3px 0 grey;
    white-space: nowrap;
    border-radius: 5px;
}
</style>
